import { Chip } from '@mui/material';
import { label } from '../i18n/labels';

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';

const STATUS_COLORS: Record<string, ChipColor> = {
  // users
  active: 'success',
  suspended: 'error',
  deleted: 'default',
  pending_verification: 'warning',
  // photos / moderation
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  // reports
  open: 'warning',
  reviewed: 'info',
  dismissed: 'default',
  upheld: 'error',
  // invitations / matches
  completed: 'success',
  partially_completed: 'info',
  cancelled: 'error',
  archived: 'default',
  expired: 'default',
};

interface StatusChipProps {
  status: string | null | undefined;
  /** Словарь переводов из i18n/labels.ts для конкретной сущности. */
  dict: Record<string, string>;
}

/** Цветной статус-бейдж с русским названием. */
export function StatusChip({ status, dict }: StatusChipProps): JSX.Element {
  if (!status) return <span>—</span>;
  return (
    <Chip
      label={label(dict, status)}
      size="small"
      color={STATUS_COLORS[status] ?? 'default'}
      variant="filled"
    />
  );
}
